import _ from 'lodash';

export default {
  sortResults: (data , sortDirection , sortIndex) => {
    data = _.orderBy(data,sortIndex,[sortDirection]);
    return data;
  }
};